import system from './system'
import home from './home'
import school from './school'
import square from './square'
import room from './room'
import library from './library'
import proList from './proList'
import notes from './notes'
import mine from './mine'
import statistics from './statistics'
import learn from './learn'

const mock = {
  system,
  home,
  school,
  square,
  room,
  proList,
  notes,
  mine,
  library,
  statistics,
  learn
}
export default mock
